import { useNavigate } from 'react-router-dom';
import { Plus } from 'react-feather';
import TablaServidor from '../tabla/TablaServidor';
import colors from '../../theme/colors';
import { COLUMNAS_PRESUPUESTOS, TABLA_PRESUPUESTOS } from './columnasPresupuestos';

const ListadoPresupuestos = () => {
  const navigate = useNavigate();

  const nuevo = (
    <button
      type="button"
      onClick={() => navigate('/presupuestos/nuevo')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '7px 14px',
        fontSize: '0.8125rem',
        fontWeight: 600,
        borderRadius: 8,
        border: 0,
        cursor: 'pointer',
        background: colors.primary,
        color: '#fff',
      }}
    >
      <Plus size={14} />
      Nuevo presupuesto
    </button>
  );

  return (
    <TablaServidor
      tablaKey={TABLA_PRESUPUESTOS}
      columnas={COLUMNAS_PRESUPUESTOS}
      ruta="listado-presupuestos"
      archivo="presupuestos"
      nombreEntidad="presupuestos"
      placeholder="Buscar por nº, nombre, apellidos, DNI o correo…"
      barraExtra={nuevo}
      claveFila={(f) => `${f.empresaId}-${f.id}`}
      onFilaClick={(f) => navigate(`/presupuestos/${String(f.empresaId).toLowerCase()}/${f.id}`)}
      tituloTarjeta={(f) => `#${f.id} · ${f.nombre || ''} ${f.apellidos || ''}`.trim()}
    />
  );
};

export default ListadoPresupuestos;
